import { render, staticRenderFns } from "./DetailsAnnonce.vue?vue&type=template&id=808811d6&scoped=true"
import script from "./DetailsAnnonce.vue?vue&type=script&lang=js"
export * from "./DetailsAnnonce.vue?vue&type=script&lang=js"
import style0 from "./DetailsAnnonce.vue?vue&type=style&index=0&id=808811d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808811d6",
  null
  
)

export default component.exports